// Compact, theme-aware preview for the "SaaS metrics library" nav announcement card.
// Coded rather than a screenshot so it stays crisp at thumbnail size.

type Trend = "up" | "down";

interface PreviewMetric {
  name: string;
  value: string;
  trend: Trend;
  spark: number[]; // relative heights 0..1
}

const METRICS: PreviewMetric[] = [
  { name: "MRR", value: "$48.2k", trend: "up", spark: [0.3, 0.45, 0.5, 0.65, 0.7, 0.85, 1] },
  { name: "NRR", value: "112%", trend: "up", spark: [0.5, 0.55, 0.6, 0.58, 0.7, 0.8, 0.9] },
  {
    name: "Gross churn",
    value: "1.8%",
    trend: "down",
    spark: [0.9, 0.8, 0.75, 0.6, 0.55, 0.4, 0.35],
  },
];

const Sparkline = ({ spark, trend }: { spark: number[]; trend: Trend }) => (
  <div className="flex items-end gap-[2px] h-5">
    {spark.map((h, i) => (
      <div
        key={i}
        className={`w-[3px] rounded-sm ${trend === "up" ? "bg-accent" : "bg-destructive"}`}
        style={{
          height: `${Math.max(h * 100, 12)}%`,
          opacity: 0.35 + (i / (spark.length - 1)) * 0.65,
        }}
      />
    ))}
  </div>
);

const MetricsLibraryPreview = () => (
  <div className="w-full aspect-video bg-background p-3 flex flex-col justify-center gap-2">
    {METRICS.map(({ name, value, trend, spark }) => (
      <div key={name} className="flex items-center justify-between gap-3">
        <div className="flex flex-col leading-tight">
          <span className="text-[11px] font-medium text-foreground">{name}</span>
          <span className={`text-[10px] ${trend === "up" ? "text-accent" : "text-destructive"}`}>
            {value}
          </span>
        </div>
        <Sparkline spark={spark} trend={trend} />
      </div>
    ))}
  </div>
);

export default MetricsLibraryPreview;
